module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.bf243bcb.ttf";